import { useState, useEffect, ChangeEvent } from 'react';
import { ImportOutlined } from '@ant-design/icons';
import { Tabs, Space, Input, Tooltip, Modal, Image, Tag } from 'antd';
import Table from '../../TableResizable';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import { TwitterOutlined } from '@ant-design/icons';
import { DownloadOutlined } from '@ant-design/icons';
import axios from 'axios';
import SweetAlert from "sweetalert2";
import { ExcelRenderer } from "react-excel-renderer";
import { useNavigate } from 'react-router-dom';
import { Backdrop, Box, CircularProgress, Fab, Typography } from '@mui/material';
import { UploadFileOutlined } from '@mui/icons-material';
import { ColumnsType } from 'antd/es/table';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
//import Utilisateur from '../../../../Models/Utilisateur';
import Utilisateur from '../../../Models/Utilisateur';
import Data from '../../../Data/Data.json'
import { Crypter } from '../../../Functions/Security/Crypter';
import Operation from '../../../Models/Operation';
import formatNumber from '../../../Functions/Traitement/FormatNumber';
//import SearchModal from '../../../SearchModal';
import SearchModal from '../../SearchModal';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import ImportSai from '../../../Types/ImportSai';
import VerifDay from '../../../Functions/Traitement/VerifDay';
//import desex
import DesExcel from '../../../Res/DescExcel.png';
//import DesExcel from
import { filter } from '@progress/kendo-data-query/dist/npm/transducers';



//import '../../../Assets/Styles/StyleForm.css';
const Swal = require('sweetalert2');

let searchRef: ParamsPicklist = { CodeAgence: '', Table: "ECPTAMPON", Colonne1: "REPECE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }

const ImportSaisieDistant = () => {
    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader();

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [StartSearchG, SeStartSearchG] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [consulActive, setConsulActive] = useState(false)
    const [sbmit, setSbmit] = useState("");
    const [data, setData] = useState<ImportSai[]>([]);
    const [fileUrl, setFileUrl] = useState<string>('');
    const [previewOpen, setpreviewOpen] = useState<boolean>();
    const [Load, SetLoad] = useState(false);
    const Navigate = useNavigate();


    useEffect(() => {
        forceUpdate({});
        if (Load === false) {
            VerifDay(user.coduti, user.codage, authHeader, Navigate);
            SetLoad(true);
        }
    }, []);


    const uploadFile = async (event: ChangeEvent<HTMLInputElement>): Promise<void> => {
        
        let fileObj = event.target.files?.[0];
        if (fileObj) {
            setFileUrl(URL.createObjectURL(fileObj));
            // Mettre à jour l'URL du fichie


            ExcelRenderer(fileObj, async (err: any, resp: any) => {
                if (err) {
                    console.log(err);
                } else {
                    const { cols, rows } = resp;
                    const datat: ImportSai[] = [];

                    let TotalDebit: number = 0;
                    let TotalCrebit: number = 0;
                    let NbrCrebit: number = 0;
                    let NbrDebit: number = 0;
                    setLoad(true);

                    // Utiliser Promise.all() pour attendre que toutes les requêtes API soient terminées
                    await Promise.all(rows.map(async (data: any, indice: number) => {
                        let Nomcpt: string = '';
                         let CodAge: string = '';
                        if (indice > 0) {
                            let config = {
                                method: 'get',
                                maxBodyLength: Infinity,
                                url: Data.ApiUrl.GetCompte,
                                headers: {
                                    'CypherNumCpte': Crypter.encrypt(data[1]),
                                    'Authorization': authHeader(),
                                    'Content-Type': 'application/json'
                                },
                            };

                            // Utiliser await pour attendre la réponse de l'API
                            const response = await axios.request(config);

                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data));
                                if (res.StatutCode === 200) {
                                    let datas: any = res.Result.Table[0];
                                  
                                    if (res.Result.Table.length > 0) {
                                        Nomcpt = datas.NOMCPT;
                                       // CodAge=datas.AGCCPT
                                        // alert("Code Agence Compte"+CodAge)
                                        // let dat = Array.isArray(datas) ? datas : (Array.isArray(datas.Rows) ? datas.Rows : []);
                                        //  let filtered = dat.filter((row: any) => row.AGCCPT !== user.codage);

                                        //  if(CodAge!=user.codage){
                                        //     SweetAlert.fire({ title: "Warning", text: "Compte " + data[1] + " n'appartient pas à l'agence de l'utilisateur", icon: "warning" })
                                        //     return
                                        //  }
                                    }
                                    
                                    /* else {
                                      SweetAlert.fire({ title: "Warning", text: "Client not found", icon: "warning" })
                                    }
                                    */
                                }
                            }
                           
                            //console.log("total D"+data[4])
                            // console.log("total D"+TotalCrebit)
                            if (data[3].toUpperCase() == "D") { 
                                NbrDebit++; 
                                TotalDebit = TotalDebit+Number(data[4]) ; }
                            else if (data[3].toUpperCase() == "C") { NbrCrebit++; TotalCrebit += Number(data[4]) ; }
                            datat.push({ AGENCE: data[0], NUMCPT: data[1], LIBELLE: data[2], SENCE: data[3].toUpperCase(), MONTANT: data[4], NOMCPT: Nomcpt });
                        }
                    }));

                    setData(datat);
                    form.setFieldValue("TotalDebit", formatNumber(TotalDebit));
                    form.setFieldValue('TotalCrebit', formatNumber(TotalCrebit));
                    form.setFieldValue("NbrCrebit", NbrCrebit);
                    form.setFieldValue("Nbrdebit", NbrDebit);
                    form.setFieldValue("Solde", formatNumber(TotalCrebit - TotalDebit));
                    form.setFieldValue("NbrTotal", NbrCrebit + NbrDebit);
                    setLoad(false);

                    // Réinitialiser la valeur de l'input de fichier
                    // event.target?.value = null;
                }
            });
        }
    };

    useEffect(() => {
        forceUpdate({});
        if (StartForm == true) { SetStartForm(false); }
    }, []);

    const columns: ColumnsType<ImportSai> = [
        {
            title: 'Agence',
            dataIndex: 'AGENCE',
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Numéro compte',
            dataIndex: 'NUMCPT',
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Ititulé',
            dataIndex: 'NOMCPT',
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Libellé',
            dataIndex: 'LIBELLE',
            ellipsis: true,
            width: 200,
        },
        {
            title: 'Sens opération',
            dataIndex: 'SENS',
            ellipsis: true,
            width: 100,
        },
        {
            title: 'Montant',
            dataIndex: 'MONTANT',
            ellipsis: true,
            width: 150,
        }
    ]



    const SetStart = async () => {

        let data = Crypter.encrypt('1');
        let data2 = Crypter.encrypt(user.codage);
        let data3= Crypter.encrypt(user.codage);
        let data4 = Crypter.encrypt(user.codage);
        setLoading(true)
        if (data.length != 0) {

            //   form.resetFields();

            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.GetReference,
                headers: {
                    'CypherTypOp': data,
                    'CypherCodAge': data2,
                     'CypherRefOp': data3,
                     'CypherStaOp': data4,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            };

            await axios.request(config)
                .then((response) => {
                    setLoading(false);
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;

                        if (res.StatutCode == 200) {
                            form.setFieldValue("Reference", res.Result);
                            setSbmit("add");
                            setAjoutActif(true);
                            setEnregActve(false)
                            setAjoutActif(true);
                            setEnregActve(false)
                            setConsulActive(true)
                            setLoading(false)
                            setConsulActive(true)
                        }
                        else {
                            SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                        }
                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error)
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                });


        }
    }



    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='Tab'>
                    <ImportOutlined />
                    Importation saisies distant
                </span>
            ),
            children:
                <div className='tabItem' >
                    <div >
                        <Box fontStyle={"inherit"} display={"flex"} width={"100%"}  className='bordure1' >
                            <Box fontStyle={"inherit"}  >
                                <SearchModal notRequired disabled={true} Titre={"Reférence"} label={"Reférence"} name={"Reference"} Parametre={searchRef} form={form} />
                            </Box>
                        </Box>
                        <Box fontStyle="inherit" className='border-left border' width={"85%"} position={"absolute"}>
                            <Box display={'flex'} justifyContent={'space-between'} gap={'50%'} marginBottom={'0.5%'}>
                                <div className="excel-import-container">
                                    <div className="file-upload">
                                        <Input addonBefore={"Upload file"} addonAfter={".xlsx"} disabled={false} accept=".xlsx" suffix={<UploadFileOutlined color='success' />} type="file" onChange={uploadFile} />
                                        {fileUrl && <input type="text" value={fileUrl} readOnly />}
                                    </div>
                                    <Box fontStyle={"inherit"} className='bordure1' >
                                        <Table sticky={true} columns={columns} size='small' pagination={false} scroll={{ y: 250, x: 800 }} dataSource={data} />
                                    </Box>
                                    <Box display={"flex"} width={"98%"} marginTop={"5px"} fontStyle="inherit" className='bordure1'>
                                        <Space.Compact >
                                            <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre crédit" name='TotalCrebit'><Input disabled /></Form.Item>
                                            <Form.Item style={{ width: '14%' }} name='NbrCrebit'><Input disabled /></Form.Item>
                                        </Space.Compact>
                                        <Space.Compact >
                                            <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre débit" name='TotalDebit'><Input disabled /></Form.Item>
                                            <Form.Item style={{ width: '14%' }} name='Nbrdebit'><Input disabled /></Form.Item>
                                        </Space.Compact>
                                        <Space.Compact >
                                            <Form.Item label="Solde Total" name='Solde'><Input disabled /></Form.Item>
                                        </Space.Compact>
                                    </Box>
                                </div>
                            </Box>
                        </Box>
                        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={load} >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </div>
                </div >,
        }
    ]

    const onFinish = (values: any) => {

        let Operation: Operation = values;
        Operation.aeducp = user.codage;
        Operation.codope = '005';
        Operation.exoner = '';
        Operation.montant = 0;
        Operation.devis = 'XAF';
        Operation.taux = 1;
        Operation.sensec = '';
        Operation.datval = '';
        Operation.codanal = '';
        Operation.libanal = '';
        Operation.refauto = '';
        Operation.refmanuel = '';
        Operation.line = 0;
        Operation.codserv = '';
        Operation.datsys = '';
        Operation.nbenef = '';
        Operation.refauto = form.getFieldValue('Reference');
        Operation.refmanuel = form.getFieldValue('Reference');
        Operation.datope = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
        Operation.numcpt = '';
        Operation.annee = user.datjour.substring(0, 4);
        Operation.mois = user.datjour.substring(5, 7);
        Operation.litige = '';
        Operation.utisai = user.coduti;
        Operation.typope = '1';
        Operation.sensec = '';
        Operation.ImportSai = data;

        let total = form.getFieldValue('NbrCrebit') + form.getFieldValue('Nbrdebit');

        // Client.DateDelcni = Client.DateDelcni? (new Date(Client.DateDelcni)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00" : ""
        // Client.DATNAI = (new Date(Client.DATNAI)).toLocaleDateString("fr").replaceAll('/', '-')+" 00:00:00"
        // let Typeo = form.getFieldValue('Sence') == "D" ? "Debit" : "Credit";
        if (Operation.ImportSai.length > 0) {
            if (form.getFieldValue('Solde') == 0) {
                SweetAlert.fire({
                    title: "Saisie D'opération",
                    text: "Voulez-vous Importez " + total + " Opérations ? ",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoad(true);
                        setIsSubmit(true)
                        //let group = profilsDistant.find(()=>)
                        //console.log('Received values of form: ', Crypter.encrypt(JSON.stringify(Client)));

                        let data = Crypter.encrypt(JSON.stringify(Operation));

                        let config = {
                            method: 'post',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.SaisieOperation,
                            headers: {
                                'Accept': '*/*',
                                'cypherNumcptEm': Crypter.encrypt(form.getFieldValue('NUMCPT')),
                                'cypherLibEm': Crypter.encrypt(form.getFieldValue('lib_CodeOpe')),
                                'cypheNumcptRecpt': Crypter.encrypt(form.getFieldValue('')),
                                'cypherLibRecpt': Crypter.encrypt(form.getFieldValue('')),
                                'cypherDispon': Crypter.encrypt('0'),
                                'Authorization': authHeader(),
                                'cypherOption': Crypter.encrypt('3'),
                                'Content-Type': 'application/json'
                            },
                            data: data
                        };

                        axios.request(config)
                            .then((response) => {
                                setLoad(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                    let result = res.Result;
                                    if (res.StatutCode == 200) {

                                        // form.resetFields()
                                        localStorage.clear();
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: res.Message, text: result, icon: "success" })
                                        setData([]);
                                        form.resetFields();
                                        setSbmit("");

                                        // GetAllOperation();
                                    }
                                    else if (res.StatutCode == 300) {
                                        SweetAlert.fire({ title: "Warning", text: JSON.stringify(res.Result).replaceAll("\",\"Status\":\"209", "").replaceAll("[", '').replace("\"}]", '').replace("\"}]", '').replaceAll("\"", '').replaceAll("{", ''), icon: "warning" })
                                    }
                                    else {
                                        SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                                    }
                                }
                            })
                            .catch((error) => {
                                setLoad(false)
                                console.log(error)
                                SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                            });
                    }
                })
            } else SweetAlert.fire({ title: "Enregistrement Impossible écritures Déséquilibrées", text: ' Veuillez Vérifier les Opérations a Saisies', icon: "error" })

        } else SweetAlert.fire({ title: "Error", text: "Aucun élément ", icon: "question" })


        setLoad(false)
    };

    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };



    function modifButton() {
        setModifActve(true)
        setAjoutActif(true)
        setEnregActve(false)
        setConsulActive(true)
    }

    function annulButton() {
        setAjoutActif(false)
        setEnregActve(true)
        setData([])
    }

    function modif() {
        modifButton()

    }

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b>{window.location.pathname}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Box fontStyle="inherit"  className='bordure1'>
                    <Modal footer={false} open={previewOpen} title={"Simple Exemple Format to Import File In Excel "} onOk={e => { setpreviewOpen(false) }} onCancel={e => { setpreviewOpen(false) }}>
                    <a href={require('../../../Res/ExcelEcriture.xlsx')}
                        download="Example-Excel-format"
                        target="_blank"
                        rel="noreferrer" > <Button type='dashed' icon={<DownloadOutlined />} > download example file</Button> </a>
                    <Image preview={true} src={DesExcel} />
                </Modal>
                </Box>
               
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button> */}

                                <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button>
                                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>
                                <Button size='large' disabled={false} className='bt_add' onClick={annulButton} type="ghost" htmlType="reset" block>
                                    Annuler
                                </Button>

                                <Tooltip title="Infos about the specification format to Upload "    >
                                    <Button disabled={false} size='large' className='bt_add' onClick={(e) => { setpreviewOpen(true) }} type="ghost"  block  >
                                        Format fichier
                                    </Button>
                                </Tooltip>

                            </Space>
                        </Form.Item>
                    </div>
                      <Box fontStyle="inherit"  className='bordure1'>
                        <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                       </Box> 
                    {/* <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                        </div>
                        
                    </div> */}
                </Form>
            </Spin>
        </div>

    );
}
export default ImportSaisieDistant;